var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29 4.912v22.176A1.91 1.91 0 0 1 27.088 29H4.912A1.91 1.91 0 0 1 3 27.088V4.912A1.91 1.91 0 0 1 4.912 3h22.176A1.91 1.91 0 0 1 29 4.912m-18.353 8.03H6.824v12.235h3.823zm.344-4.207a2.203 2.203 0 0 0-2.187-2.217h-.069a2.218 2.218 0 1 0 0 4.435 2.2 2.2 0 0 0 2.256-2.149zm14.186 9.009c0-3.679-2.34-5.109-4.665-5.109a4.36 4.36 0 0 0-3.87 1.973h-.107v-1.667h-3.594v12.236h3.824v-6.508a2.54 2.54 0 0 1 2.294-2.738h.145c1.216 0 2.118.765 2.118 2.692v6.554h3.824z"
  })));
};
export default SvgLinkedin;